import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "feature-blocks" }
const _hoisted_2 = { class: "section-inner" }
const _hoisted_3 = { class: "feature-content" }
const _hoisted_4 = { class: "feature-header" }
const _hoisted_5 = ["alt", "src"]
const _hoisted_6 = { class: "feature-title" }
const _hoisted_7 = { class: "feature-description" }
const _hoisted_8 = { class: "feature-list" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "check-icon",
  alt: "Check",
  src: "https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg"
}, null, -1)
const _hoisted_10 = { class: "feature-item-text" }
const _hoisted_11 = { class: "feature-image" }
const _hoisted_12 = ["alt", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blocks, (block, idx) => {
      return (_openBlock(), _createElementBlock("section", {
        key: block.title,
        class: _normalizeClass(["feature-section", [{ alt: idx % 2 === 1 }, block.reverse ? 'reverse' : '']])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                class: "feature-icon",
                alt: block.iconAlt,
                src: block.iconSrc
              }, null, 8, _hoisted_5),
              _createElementVNode("h3", _hoisted_6, _toDisplayString(block.title), 1)
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(block.description), 1),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.bullets, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: "feature-item"
                }, [
                  _hoisted_9,
                  _createElementVNode("p", _hoisted_10, _toDisplayString(item), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              alt: block.imageAlt,
              src: block.imageSrc,
              class: _normalizeClass([
              block.imageFit === 'contain' ? 'contain' : '',
              block.imagePosition ? `pos-${block.imagePosition}` : '',
            ]),
              loading: "lazy",
              decoding: "async"
            }, null, 10, _hoisted_12)
          ])
        ])
      ], 2))
    }), 128))
  ]))
}